module.exports = __webpack_public_path__ + "static/media/Health_yoga.5d5777ad.png";